import { configurationSchema } from '@exam-management/configuration';

export const configuration = configurationSchema.parse({
  mode: import.meta.env.MODE,
  logLevel: import.meta.env.VITE_LOG_LEVEL,
  graphql: {
    apiUrl: import.meta.env.VITE_GRAPHQL_API_URL,
    defaultFetchPolicy: import.meta.env.VITE_GRAPHQL_DEFAULT_FETCH_POLICY,
  },
  loginUrl: import.meta.env.VITE_LOGIN_URL,
  appShell: import.meta.env.VITE_APP_SHELL,
  examRoom: {
    previewUrl: import.meta.env.VITE_EXAM_ROOM_PREVIEW_URL,
  },
  modules: {
    userManagement: {
      azureLoginUrl: import.meta.env.VITE_AZURE_LOGIN_URL,
      restrictedUserEmailDomains: import.meta.env.VITE_RESTRICTED_USER_EMAIL_DOMAINS,
      internalUserEmailDomains: import.meta.env.VITE_INTERNAL_USER_EMAIL_DOMAINS,
    },
    qcontent: {
      singleImportTemplateUrl: import.meta.env.VITE_QCONTENT_SINGLE_IMPORT_TEMPLATE_URL,
      itemSetImportTemplateUrl: import.meta.env.VITE_QCONTENT_ITEM_SET_IMPORT_TEMPLATE_URL,
      maxSubQuestions: import.meta.env.VITE_QCONTENT_MAX_SUB_QUESTIONS,
    },
  },
});
